const hasStock = (stock) => !!stock && stock.status !== "OUT_OF_STOCK" && stock.status !== "UNKNOWN";
export {
  hasStock
};
//# sourceMappingURL=has-stock.js.map
